
import type { SmartType } from './smartTable.types';
export const normalizeLabel = (key: string) =>
  key.replace(/[\_\-]+/g, ' ').replace(/\s+/g, ' ').trim().replace(/^\w/, (c) => c.toUpperCase());
const isValidDate = (val: any) => { if (typeof val !== 'string') return false; return isNaN(Number(val)) && !isNaN(Date.parse(val)); };
export const inferType = (value: any): SmartType => {
  if (Array.isArray(value) && value.every((v) => typeof v === 'string')) return 'arrayString';
  const t = typeof value;
  if (t === 'boolean') return 'boolean';
  if (t === 'number' && !Number.isNaN(value)) return 'number';
  if (t === 'string' && isValidDate(value)) return 'date';
  return 'text';
};
export const getStorageKey = (cfg?: { storageKey?: string }) => cfg?.storageKey ?? 'smart-table:default';
